import { IColumnDef } from '../../../../../../Types/ColumnDefType';
import EDView from '../../../../../../BaseComponents/View/EDView';
import EDGrid from '../../../../../../BaseComponents/GridComponents/EDGrid';
import NodeQuery from '../../../../../../Components/QueryComponents/NodeQuery/NodeQuery';
import {
  getStringValue,
  attributeDefToDataPath,
} from '../../../../../../Utils/dataUtils';
import { headerColumns } from '../../../Utils/defaultColumns';
import EDBreadcrumb from '../../../../../../BaseComponents/Breadcrumb/EDBreadcrumb';
import { createPortal } from 'react-dom';
import {
  HEADER,
  HeaderReference,
  SEPARATOR,
} from '../../RutinBreadcrumbs/BreadcrumbsContext';
import { EDBreadcrumbSeparator } from '../../../../../../BaseComponents/Breadcrumbs/EDBreadcrumbSeparator';

interface IProps {
  id: string | null;
  caption?: string;
  collectionName: string;
  onClick?: () => void;
  headerRef?: HeaderReference;
}
const BusinessDataObjectDetailHeader = (props: IProps) => {
  const columndefs: IColumnDef[] = headerColumns(props.collectionName);
  const fieldDefs = columndefs.map(coldef => coldef.attributeDef);
  return props.headerRef ? (
    <>
      {props.headerRef[HEADER].current &&
        createPortal(
          <EDView>
            <EDGrid
              container
              alignContent="center"
              alignItems="center"
              spacing={8}
            >
              <EDGrid item xs>
                <NodeQuery
                  id={props.id}
                  collectionName={props.collectionName}
                  fieldDefs={fieldDefs}
                  disableAddRefetchButtonQuery
                >
                  {(loading, node) => (
                    <EDBreadcrumb
                      onClick={props.onClick}
                      caption={
                        ((props.caption && props.caption + ': ') || '') +
                        columndefs
                          .map(columndef =>
                            getStringValue(
                              node,
                              attributeDefToDataPath(columndef.attributeDef)
                            )
                          )
                          .join(' ')
                      }
                    />
                  )}
                </NodeQuery>
              </EDGrid>
            </EDGrid>
          </EDView>,
          props.headerRef[HEADER].current
        )}
      {props.headerRef[SEPARATOR]?.current &&
        createPortal(
          <EDBreadcrumbSeparator />,
          props.headerRef[SEPARATOR].current
        )}
    </>
  ) : (
    <></>
  );
};
export default BusinessDataObjectDetailHeader;
